var q = Object.defineProperty;
var D = (t, e, s) => e in t ? q(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var i = (t, e, s) => D(t, typeof e != "symbol" ? e + "" : e, s);
const d = (t, e) => `${t}_${e}`, u = (t, e) => new URLSearchParams(window.location.search).get(t), X = (t) => {
  const e = K(t);
  return e ? e.exp : 0;
}, K = (t) => {
  const e = b(t);
  return e || null;
}, b = (t) => {
  try {
    const s = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), a = decodeURIComponent(window.atob(s).split("").map((n) => "%" + ("00" + n.charCodeAt(0).toString(16)).slice(-2)).join(""));
    return JSON.parse(a);
  } catch {
    return null;
  }
}, j = (t) => {
  const e = /* @__PURE__ */ new Date();
  return !((X(t) - 30) * 1e3 > e.getTime());
}, I = (t) => {
  window.onmessage || (window.onmessage = (e) => {
    window.dispatchEvent(new CustomEvent(e.data.action, {
      detail: {
        event: e
      }
    }));
  });
};
var o = /* @__PURE__ */ ((t) => (t.INIT = "INIT", t.TOKEN = "TOKEN", t.HEIGHT = "HEIGHT", t.NEXT = "NEXT", t.BACK = "BACK", t.NOTIFICATION = "NOTIFICATION", t))(o || {}), T = /* @__PURE__ */ ((t) => (t.ADMIN_APP_LOADER = "ADMIN_APP_LOADER", t.ADMIN_APPOINTMENT_DETAILS = "ADMIN_APPOINTMENT_DETAILS", t.EXPERIENCE_INSTANT_BOOKING_FORM = "EXPERIENCE_INSTANT_BOOKING_FORM", t.EXPERIENCE_CONFIRMATION_PAGE = "EXPERIENCE_CONFIRMATION_PAGE", t))(T || {}), J = /* @__PURE__ */ ((t) => (t.SUCCESS = "SUCCESS", t.INFO = "INFO", t.WARNING = "WARNING", t.ERROR = "ERROR", t))(J || {});
const Q = (t, e) => {
  window.addEventListener(d(t, o.TOKEN), () => e());
}, E = (t, e, s) => {
  const a = {
    action: d(t, o.TOKEN),
    payload: {
      token: s
    }
  };
  e.postMessage(a, { targetOrigin: "*" });
}, N = {
  CLIENT_LOADING_TIMEOUT: 16e3,
  CLIENT_ON_NEXT_TIMEOUT: 8e3
}, y = (t, e) => {
  window.addEventListener(d(t, o.HEIGHT), (s) => e(s.detail.event.data.payload.height));
}, L = (t, e) => {
  const s = {
    action: d(t, o.NEXT)
  };
  return e.postMessage(s, { targetOrigin: "*" }), new Promise((a) => {
    let n = !0;
    setTimeout(() => {
      n && (a(!0), n = !1);
    }, N.CLIENT_ON_NEXT_TIMEOUT), window.addEventListener(d(t, o.NEXT), (c) => {
      n && (a(c.detail.event.data.payload.isAccepted), n = !1);
    });
  });
}, f = (t, e) => {
  window.addEventListener(d(t, o.NOTIFICATION), (s) => {
    const a = s.detail.event.data.payload;
    e(a.message, a.type);
  });
}, V = (t, e) => {
  window.addEventListener(d(t, o.BACK), () => e());
}, A = (t, e) => {
  window.addEventListener(d(t, o.INIT), (s) => {
    e(s.detail.event.source);
  });
}, Y = (t, e, s, a, n) => {
  const c = {
    action: d(t, o.INIT),
    payload: {
      shopId: s,
      locale: a,
      extra: n
    }
  };
  e == null || e.postMessage(c, { targetOrigin: "*" });
}, Z = (t, e, s, a, n, c, H, z, B, W, U, $) => {
  const G = {
    action: d(t, o.INIT),
    payload: {
      sessionId: s,
      shopId: a,
      serviceId: n,
      variantId: c,
      quantity: H,
      resources: z,
      locale: B,
      timezone: W,
      slot: U,
      extra: $
    }
  };
  e == null || e.postMessage(G, { targetOrigin: "*" });
};
class R {
  constructor(e) {
    i(this, "token");
    i(this, "messageId");
    i(this, "source", null);
    i(this, "shopId");
    i(this, "locale");
    i(this, "extra");
    i(this, "isWaitingForClientToLoad", !1);
    this.token = null, this.messageId = e.messageId, this.shopId = e.shopId, this.locale = e.locale, this.extra = e.extra, this.isWaitingForClientToLoad = !0, setTimeout(() => {
      this.isWaitingForClientToLoad && (e.onInitEnded(!1), this.isWaitingForClientToLoad = !1);
    }, N.CLIENT_LOADING_TIMEOUT), I(), A(this.messageId, (s) => {
      this.source = s, Y(
        this.messageId,
        this.source,
        this.shopId,
        this.locale,
        this.extra
      ), this.isWaitingForClientToLoad && (this.isWaitingForClientToLoad = !1, setTimeout(() => {
        e.onInitEnded(!0);
      }, 100));
    }), Q(this.messageId, async () => {
      if (this.token && !j(this.token))
        this.source && E(this.messageId, this.source, this.token);
      else {
        const s = await e.getToken();
        this.token = s, this.source && E(this.messageId, this.source, this.token);
      }
    }), e.onHeightChange && y(this.messageId, e.onHeightChange);
  }
}
class ie extends R {
  constructor(e) {
    super(e), f(this.messageId, e.onNotification), e.onBack && V(this.messageId, e.onBack);
  }
}
class ae extends R {
  constructor(e) {
    super(e), f(this.messageId, e.onNotification);
  }
}
const ee = (t) => {
  var s;
  const e = {
    action: d(t, o.TOKEN),
    payload: null
  };
  return (s = window.top) == null || s.postMessage(e, "*"), new Promise((a) => {
    window.addEventListener(d(t, o.TOKEN), (n) => {
      a(n.detail.event.data.payload.token);
    });
  });
}, _ = (t, e) => {
  window.addEventListener(d(t, o.NEXT), () => e());
}, p = (t) => {
  var s;
  const e = {
    action: d(t, o.NEXT),
    payload: {
      isAccepted: !0
    }
  };
  (s = window.top) == null || s.postMessage(e, "*");
}, F = (t) => {
  var s;
  const e = {
    action: d(t, o.NEXT),
    payload: {
      isAccepted: !1
    }
  };
  (s = window.top) == null || s.postMessage(e, "*");
}, te = (t) => {
  var s;
  const e = {
    action: d(t, o.BACK),
    payload: null
  };
  (s = window.top) == null || s.postMessage(e, "*");
}, M = (t, e, s) => {
  var n;
  const a = {
    action: d(t, o.NOTIFICATION),
    payload: {
      message: e,
      type: s
    }
  };
  (n = window.top) == null || n.postMessage(a, "*");
}, m = (t) => {
  var s;
  const e = {
    action: d(t, o.INIT)
  };
  return (s = window.top) == null || s.postMessage(e, "*"), new Promise((a) => {
    window.addEventListener(d(t, o.INIT), (n) => {
      a(n.detail.event.data.payload);
    });
  });
}, x = (t) => {
  new ResizeObserver((s) => {
    var n;
    const a = {
      action: d(t, o.HEIGHT),
      payload: {
        height: s[0].target.clientHeight
      }
    };
    (n = window.top) == null || n.postMessage(a, "*");
  }).observe(document.body);
};
class P {
  constructor(e) {
    i(this, "messageId");
    i(this, "shopId");
    i(this, "locale");
    i(this, "getShopId", () => this.shopId);
    i(this, "getLocale", () => this.locale);
    i(this, "getToken", () => ee(this.messageId));
    this.messageId = e.messageId, this.shopId = e.shopId, this.locale = e.locale, x(this.messageId);
  }
}
const r = class r extends P {
  constructor() {
    super(...arguments);
    i(this, "showNotification", (s, a) => M(this.messageId, s, a));
    i(this, "navBack", () => te(this.messageId));
  }
};
i(r, "init", async () => {
  I();
  const s = u("messageId") ?? "", a = await m(s);
  return new r({
    messageId: s,
    shopId: a.shopId,
    locale: a.locale
  });
});
let w = r;
const h = class h extends P {
  constructor(s) {
    super(s);
    i(this, "appointmentId");
    i(this, "getAppointmentId", () => this.appointmentId);
    i(this, "showNotification", (s, a) => M(this.messageId, s, a));
    this.appointmentId = s.appointmentId;
  }
};
i(h, "init", async () => {
  var n;
  I();
  const s = u("messageId") ?? "", a = await m(s);
  return new h({
    messageId: s,
    shopId: a.shopId,
    locale: a.locale,
    appointmentId: (n = a.extra) == null ? void 0 : n.appointmentId
  });
});
let O = h;
class k {
  constructor(e) {
    i(this, "url");
    i(this, "messageId");
    i(this, "source", null);
    i(this, "sessionId");
    i(this, "shopId");
    i(this, "serviceId");
    i(this, "variantId");
    i(this, "quantity");
    i(this, "resources");
    i(this, "locale");
    i(this, "timezone");
    i(this, "slot");
    i(this, "extra");
    i(this, "isWaitingForClientToLoad", !1);
    i(this, "getBaseURL", () => `${this.url}?messageId=${this.messageId}&sessionId=${this.sessionId}&shopId=${this.shopId}&serviceId=${this.serviceId}&variantId=${this.variantId}&quantity=${this.quantity}&resources=${JSON.stringify(this.resources.map((e) => e.id))}&locale=${this.locale}&timezone=${this.timezone}&slot=${this.slot.getTime()}`);
    this.url = e.url, this.messageId = e.messageId, this.sessionId = e.sessionId, this.shopId = e.shopId, this.serviceId = e.serviceId, this.variantId = e.variantId, this.quantity = e.quantity, this.resources = e.resources, this.locale = e.locale, this.timezone = e.timezone, this.slot = e.slot, this.extra = e.extra, this.isWaitingForClientToLoad = !0, setTimeout(() => {
      this.isWaitingForClientToLoad && (e.onInitEnded(!1), this.isWaitingForClientToLoad = !1);
    }, N.CLIENT_LOADING_TIMEOUT), I(), A(this.messageId, (s) => {
      this.source = s, Z(
        this.messageId,
        this.source,
        this.sessionId,
        this.shopId,
        this.serviceId,
        this.variantId,
        this.quantity,
        this.resources,
        this.locale,
        this.timezone,
        this.slot,
        this.extra
      ), this.isWaitingForClientToLoad && (this.isWaitingForClientToLoad = !1, setTimeout(() => {
        e.onInitEnded(!0);
      }, 100));
    }), e.onHeightChange && y(this.messageId, e.onHeightChange);
  }
}
class ne extends k {
  constructor() {
    super(...arguments);
    i(this, "askForDone", async () => this.source ? L(this.messageId, this.source) : !this.isWaitingForClientToLoad);
    i(this, "getURL", () => `${this.getBaseURL()}&target=${T.EXPERIENCE_INSTANT_BOOKING_FORM}`);
  }
}
class oe extends k {
  constructor() {
    super(...arguments);
    i(this, "askForConfirm", async () => this.source ? L(this.messageId, this.source) : !this.isWaitingForClientToLoad);
    i(this, "getURL", () => `${this.getBaseURL()}&target=${T.EXPERIENCE_INSTANT_BOOKING_FORM}`);
  }
}
class S {
  constructor(e) {
    i(this, "messageId");
    i(this, "sessionId");
    i(this, "shopId");
    i(this, "serviceId");
    i(this, "variantId");
    i(this, "quantity");
    i(this, "resources");
    i(this, "locale");
    i(this, "timezone");
    i(this, "slot");
    i(this, "getSessionId", () => this.sessionId);
    i(this, "getShopId", () => this.shopId);
    i(this, "getProductId", () => this.serviceId);
    i(this, "getVariantId", () => this.variantId);
    i(this, "getQuantity", () => this.quantity);
    i(this, "getResources", () => this.resources);
    i(this, "getLocale", () => this.locale);
    i(this, "getTimezone", () => this.timezone);
    i(this, "getSlot", () => this.slot);
    this.messageId = e.messageId, this.sessionId = e.sessionId, this.shopId = e.shopId, this.serviceId = e.serviceId, this.variantId = e.variantId, this.quantity = e.quantity, this.resources = e.resources, this.locale = e.locale, this.timezone = e.timezone, this.slot = e.slot, x(this.messageId);
  }
}
const l = class l extends S {
  constructor() {
    super(...arguments);
    i(this, "onConfirm", (s) => _(this.messageId, s));
    i(this, "acceptConfirm", () => p(this.messageId));
    i(this, "rejectConfirm", () => F(this.messageId));
  }
};
i(l, "init", async () => {
  I();
  const s = u("messageId") ?? "", a = await m(s);
  return new l({
    messageId: s,
    sessionId: a.sessionId,
    shopId: a.shopId,
    serviceId: a.serviceId,
    variantId: a.variantId,
    quantity: a.quantity,
    resources: a.resources,
    locale: a.locale,
    timezone: a.timezone,
    slot: a.slot
  });
});
let v = l;
const g = class g extends S {
  constructor(s) {
    super(s);
    i(this, "appointmentId");
    i(this, "getAppointmentId", () => this.appointmentId);
    i(this, "onDone", (s) => _(this.messageId, s));
    i(this, "acceptDone", () => p(this.messageId));
    i(this, "rejectDone", () => F(this.messageId));
    this.appointmentId = s.appointmentId;
  }
};
i(g, "init", async () => {
  I();
  const s = u("messageId") ?? "", a = await m(s);
  return new g({
    messageId: s,
    sessionId: a.sessionId,
    shopId: a.shopId,
    serviceId: a.serviceId,
    variantId: a.variantId,
    quantity: a.quantity,
    resources: a.resources,
    locale: a.locale,
    timezone: a.timezone,
    slot: a.slot,
    appointmentId: a.extra.appointmentId
  });
});
let C = g;
export {
  o as Action,
  w as AdminAppLoader,
  O as AdminAppointmentDetails,
  ie as AdminHostAppLoader,
  ae as AdminHostAppointmentDetails,
  T as AppTarget,
  C as ExperienceConfirmationPage,
  ne as ExperienceHostConfirmationPage,
  oe as ExperienceHostInstantBookingForm,
  v as ExperienceInstantBookingForm,
  J as NotificationType
};
